import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import CustomInput from '../../../components/CustomInput';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { useLoading } from '../../../context/LoadingContext';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { updateDepartment } from '../../../axios/Department/DepartmentApi';
import SaveIcon14pxSvg from '../../../assets/images/icons/SaveIcon14pxSvg';
import CustomInputHorizontal from '../../../components/CustomInputHorizontal';

const EditDepartmentDialog = (props) => {
   const { row, onClose, onRefresh } = props;
   const [show, hide] = useLoading();
   const { t } = useTranslation();

   const initialFormData = {
      departmentName: row?.departmentName,
      departmentPrefix: row?.departmentPrefix,
      departmentId: row?.id,
      langId: localStorage.getItem("i18nextLngId")
   };


   const [formData, setFormData] = useState(initialFormData);

   // const [validationMessages, setValidationMessages] = useState({
   //    departmentName: '',
   //    departmentPrefix: '',
   // });


   // const [isValid, setIsValid] = useState(false);



   const handleCloseDialog = () => {
      setFormData(initialFormData);
      onClose();
   };


   const updateFormDataAndValidate = (name, value) => {
      if (name === 'departmentPrefix') {
         // Giới hạn 2 ký tự + uppercase
         const trimmedValue = value.toUpperCase().slice(0, 2);

         setFormData((prevData) => ({
            ...prevData,
            [name]: trimmedValue,
         }));
      } else {
         setFormData((prevData) => ({
            ...prevData,
            [name]: value,
         }));
      }
   };

   const handleInputChange = (e) => {
      const { name, value } = e.target;
      updateFormDataAndValidate(name, value);
   };


   const handleSubmit = async (e) => {
      e.preventDefault();
      show()
      try {
         const response = await updateDepartment(formData);
         if (response.data.code === 200) {
            const code = response?.data?.data?.responseCode;
            if (code === undefined || code === 0) {
               handleCloseDialog();
               toast.success(t('common.edit-department-successfully'));
               onRefresh();
            } else {
               toast.error(response.data.data.message)
            }
         } else if (response.data.code === 500) {
            toast.error(response.data.message)
            handleCloseDialog();
         } else {
            toast.error(response.data.data.responseCode ? response.data.data.message : response.data.data.fieldErrors[0]?.message)
         }
      } catch (error) {
         if (error.response) {
            if (error.response.status !== 401) {
               toast.error(t(error?.response.data));
            }
         } else {
            toast.error(t('common.network-timeout'));
         }
      } finally {
         hide()
      }
   };

   return (
      <CustomDialog maxWidth={'sm'} open onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('common.edit-department')}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>
         <DialogContent>
            {/* <div className='grid grid-cols-1 gap-x-10 relative'> */}
            {/* <p className='pt-6 text-sm text-[#DC2626]'>
                  {t('common.required-fields-are-marked-in-red')} "*".
               </p> */}
            
            <div className='mt-4 grid grid-cols-12 items-center'>
               <label className='col-span-12' htmlFor="departmentName">{t('common.department-name')} <span className='text-[#DC2626] col-span-12'>*</span></label>
               <div className='col-span-12'>
                  <CustomInput
                     inputType='text'
                     name='departmentName'
                     placeholder={t('common.department-name')}
                     handleInputChange={handleInputChange}
                     value={formData.departmentName}
                  />
               </div>
            </div>
            <div className='mt-4 grid grid-cols-12 items-center'>
               <label className='col-span-12' htmlFor="departmentPrefix">{t('common.department-prefix')} <span className='text-[#DC2626] col-span-12'>*</span></label>
               <div className='col-span-12'>
                  <CustomInput
                     inputType='text'
                     name='departmentPrefix'
                     placeholder={t('common.department-prefix')}
                     handleInputChange={handleInputChange}
                     value={formData.departmentPrefix}
                  />
               </div>
            </div>


            {/* </div> */}
         </DialogContent>
         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                  <CloseIcon />
                  <p>{t('button.cancel')}</p>
               </ControlpanelSecondaryButton>
               <ControlpanelPrimaryButton onClick={handleSubmit} disabled={!formData.departmentName || !formData.departmentPrefix}>
                  <SaveIcon14pxSvg />
                  <p>{t('button.save')}</p>
               </ControlpanelPrimaryButton>
            </div>
         </DialogActions>
      </CustomDialog>

   );
};

export default EditDepartmentDialog;
